import React, { Component, Fragment } from 'react';
import { Form, Button, Input, message, Modal } from 'antd';
import loginLeftBg from '../../assets/login-left-bg.png';
import zdLogo from '../../assets/logo.png';
import emitter from '../../util/emitter';
import send from '../../util/request';
import { CODE_PASSWORD_CHANGE_REQUIRED } from '../../constant';
import './login.less';
import { apiLog } from '../../api';

const { localStorage, location, open } = window;
class Login extends Component {
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;
    validateFields().then(res => {
      send({
        url: '/ipp/user/login',
        method: 'POST',
        data: {
          phone: res.username.trim() || '',
          password: res.password.trim() || ''
        }
      }).then(res => {
        const { data: { msg, code, data } } = res;
        console.log('🚀 ~ file: Login.js:26 ~ Login ~ validateFields ~ data:', data);
        console.log('🔑 ~ Login ~ response code:', code, 'msg:', msg);
        if (+code === 0) {
          const { token, user_info: { company_id, username, account, id }, company_info: { company_name, warehouse_type,group_type } } = data;
          localStorage.setItem('token', token);
          localStorage.setItem('userName', `${company_name ? company_name : ''}(${username})`);
          localStorage.setItem('account', account);
          localStorage.setItem('companyId', company_id);
          localStorage.setItem('companyName', company_name);
          localStorage.setItem('warehouse_type', warehouse_type);
          localStorage.setItem('user_id', id);
          localStorage.setItem('group_type', group_type);
          localStorage.removeItem('select_rows_cache');
          // select_rows_cache
          emitter.emit('login', () => {
            const preHref = localStorage.getItem('preHref');
            if (preHref && location.pathname === '/login') {
              localStorage.removeItem('preHref');
              open(preHref, '_self');
            } else {
              this.props.history.push('/basic/index');
            }
            apiLog({
              path: this.props.location.pathname,
              path_info: '',
              params: this.props.location.search,
              source: 2,
              uid:id
            });
          });
        } else if (+code === CODE_PASSWORD_CHANGE_REQUIRED) {
          Modal.confirm({
            content: msg,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              this.props.history.push('/retrieve');
            },
          });
        } else {
          message.error(msg);
          this.formRef.current.setFieldsValue({ password: '' });
        }
      });
    });
  }

  render() {
    return (
      <Fragment>
        <div className="login" style={{ height: '100vh' }}>
          <div className="content">
            <div className="left">
              <img alt="管理系统" src={loginLeftBg} />
            </div>
            <div className="right">
              <div className="title">
                <img className="logo" alt="logo" src={zdLogo}></img>
                <div>正大集团采购平台</div>
              </div>
              <div className="log">登录</div>
              <Form
                ref={this.formRef}
                style={{ marginTop: 40, fontSize: 12, width: 260 }}
                onFinish={this.handleSubmit}>
                <Form.Item
                  className="customer-login-input"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: '请输入账号'
                    },
                    // {
                    //   pattern: new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/),
                    //   message: '账号格式不正确'
                    // }
                  ]}>
                  <div className="form-item">
                    <div className="form-label">账号</div>
                    <Input type="text" className="form-input" />
                  </div>
                </Form.Item>
                <Form.Item
                  className="customer-login-input"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: '密码不能为空'
                    }
                  ]}>
                  <div className="form-item">
                    <div className="form-label">密码</div>
                    <Input type="password" className="form-input" />
                  </div>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: '100%', height: '40px', borderRadius: '4px', marginTop: '20px' }}
                  >
                    登录
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default Login;